import { moduleNames } from 'pages/Stores/components/modules';
import { createFavoriteProductsConfig } from './FavoriteProductsConfig';

const defaultValues = { selectedItems: [] };

export const createFavoriteProductsModule = (useAvailableItems) => ({
  moduleName: moduleNames.FAVORITE_PRODUCTS,
  nameTranslationPath: 'favouriteProducts.title',
  descriptionTranslationPath: 'favouriteProducts.productsModuleDescription',
  iconClassName: 'bi bi-lightbulb-fill',
  defaultValues,
  isValid: (values) => values.selectedItems?.length > 0,
  buildPayload: (values) => values.selectedItems.map((item) => item.uid),
  parseApiData: (module) => ({
    selectedItems:
      module.favorite_products || (module.favorite_product ? [module.favorite_product] : []),
  }),
  ConfigComponent: createFavoriteProductsConfig(useAvailableItems),
});
